var initdealCode = function ($) {
  let fristShowlist = []
  let specialList = []
  let allCodeDate = []
  let porductLength = $('.product-card').length
  let url_position = ''
  const other_page_code = $('#other_page_code').val()
  const url = window.location.pathname
  if (
    url === '/collections/electric-nail-drill' ||
    url === '/collections/nail-lamp' ||
    url === '/collections/bits' ||
    url === '/collections/nail-dust-collector'
  ) {
    return false
  }
  if (url.indexOf('deals') !== -1) {
    url_position = 'deals'
  } else if (url.indexOf('collections') !== -1) {
    url_position = 'collection'
  } else if (other_page_code !== undefined) {
    const otherPageCodeList = other_page_code.split(';')
    otherPageCodeList.forEach((ele) => {
      if (ele !== '' && url.indexOf(ele) !== -1) {
        url_position = 'otherPages'
      }
    })
  }

  if (url_position === '') {
    return false
  }

  for (var i = 0; i < porductLength; i++) {
    fristShowlist.push($('.product-card')[i].getAttribute('handle'))
    // product-card-new
    const res = $('.product-card__figure>a')[i] ? getUrlParam($('.product-card__figure>a')[i].getAttribute('href')) : ''
    if (res !== '') {
      specialList.push({
        variant: res,
        index: i
      })
    }
  }
  initCodeList()

  function initCodeList() {
    new Promise((resolve, reject) => {
      $.ajax({
        type: 'post',
        url: `https://api-beta.originlinks.com/shopify-app/shopify/code/display/show`,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
          app_admin_url: 'melodysusie.myshopify.com',
          position: url_position,
          product_handles: fristShowlist
        }),
        success: function (res) {
          fristShowlist.forEach((ele, index) => {
            res.data.forEach((inele) => {
              if (ele === inele.product_handle) {
                allCodeDate.push({
                  index: index,
                  variant_id: inele.variant_id,
                  product_handle: inele.product_handle,
                  imageFist: inele.imageFist,
                  position: inele.position
                })
              }
            })
          })
          allCodeDate.forEach((ele) => {
            if (ele.position === 1) {
              setCode(ele)
            }
          })
          // cover
          specialList.forEach((ele, index) => {
            allCodeDate.forEach((inele) => {
              if (ele.variant === inele.variant_id.toString() && inele.index === ele.index) {
                featuredShowCode(ele.index, Number(ele.variant))
              }
            })
          })
          resolve()
        },
        error: function (error) {
          console.log(error)
          reject()
        }
      })
    })
  }

  function setCode(row) {
    try {
      // match variant_id
      const href = $('.product-card').eq(row.index).children('.product-card__figure').children('a').attr('href');
      const urlObject = new URL(`https://www.melodysusie.com${href}`);
      const params = new URLSearchParams(urlObject.search);
      const variant = params.get('variant') || '';
      if (variant !== '' && variant.toString() !== row.variant_id.toString()) {
        const filteredProducts = allCodeDate.filter(function(product) {
          return row.index === product.index && product.variant_id.toString() === variant.toString()
        })
        if (filteredProducts.length !== 0) {
          setCode(filteredProducts[0])
        }
        return false
      }
      if (row.imageFist.style === 1) {
        $('.product-card').eq(row.index).children('.product-card__figure').after(`
            <div class="homepageicon-box">
              <img class="homepageicon-img" src="${row.imageFist.style1.baseMap}?d=400x400&format=png">
              <div class="homepageicon">
                <div class="homepageicon-val" style="color: ${row.imageFist.style1.value.color}">${row.imageFist.style1.value.value}%</div>
                <div class="homepageicon-off" style="color: ${row.imageFist.style1.off.color}">OFF</div>
              </div>
            </div>
          `)
      } else if (row.imageFist.style === 2 && row.imageFist.style2.outMap !== null) {
        $('.product-card').eq(row.index).children('.product-card__figure').children('a').addClass('code-original')
        $('.product-card').eq(row.index).children('.product-card__figure').addClass('code-card')

        $('.product-card').eq(row.index).children('.product-card__figure').children('a').after(`
        <div class="homepagebox">
          <a href="/products/${row.product_handle}?variant=${row.variant_id}" class="code-product-img">
            <img class="code-product-img-bg" src="${row.imageFist.style2.outMap}?d=400x400&format=png">
          </a>
        </div>
        `)
        $('.product-card').eq(row.index).css('transform', 'translateY(0px)')
      } else if (row.imageFist.style === 3 && row.imageFist.style3.outMap !== null) {
        $('.product-card').eq(row.index).children('.product-card__figure').children('a').addClass('code-original')
        $('.product-card').eq(row.index).children('.product-card__figure').addClass('code-card')

        $('.product-card').eq(row.index).children('.product-card__figure').children('a').after(`
        <div class="homepagebox">
          <a href="/products/${row.product_handle}?variant=${row.variant_id}" class="code-product-img">
            <img class="code-product-img-bg" src="${row.imageFist.style3.outMap}?d=400x400&format=png">
          </a>
        </div>
        `)
        $('.product-card').eq(row.index).css('transform', 'translateY(0px)')
      }
    } catch (error) {
      console.log(error)
    }
  }

  function haveSetCode(row) {
    try {
      if (row.imageFist.style === 1) {
        $('.product-card').eq(row.index).children('.homepageicon-box').show()
        $('.product-card').eq(row.index).find('.homepageicon-val').html(`${row.imageFist.style1.value.value}%`)
      } else if (row.imageFist.style === 2 && row.imageFist.style2.outMap !== null) {
        $('.product-card').eq(row.index).children('.product-card__figure').addClass('code-card')
  
        $('.product-card').eq(row.index).children('.product-card__figure').children('a').addClass('code-original')
  
        $('.product-card').eq(row.index).find('.homepagebox').show()
  
        $('.product-card')
          .eq(row.index)
          .find('.code-product-img')
          .attr('href', `/products/${row.product_handle}?variant=${row.variant_id}`)
        $('.product-card').eq(row.index).css('transform', 'translateY(0px)')
  
        if ($('.product-card').eq(row.index).find('.code-product-img-bg').attr('src') !== row.imageFist.style2.outMap) {
          $('.product-card')
            .eq(row.index)
            .find('.code-product-img-bg')
            .attr('src', row.imageFist.style2.outMap + '?d=400x400&format=png')
        }
      } else if (row.imageFist.style === 3 && row.imageFist.style3.outMap !== null) {
        $('.product-card').eq(row.index).children('.product-card__figure').addClass('code-card')
  
        $('.product-card').eq(row.index).children('.product-card__figure').children('a').addClass('code-original')
  
        $('.product-card').eq(row.index).find('.homepagebox').show()
  
        $('.product-card')
          .eq(row.index)
          .find('.code-product-img')
          .attr('href', `/products/${row.product_handle}?variant=${row.variant_id}`)
  
        $('.product-card').eq(row.index).css('transform', 'translateY(0px)')
  
        if ($('.product-card').eq(row.index).find('.code-product-img-bg').attr('src') !== row.imageFist.style3.outMap) {
          $('.product-card')
            .eq(row.index)
            .find('.code-product-img-bg')
            .attr('src', row.imageFist.style3.outMap + '?d=400x400&format=png')
        }
      }
    } catch (error) {
      console.log(error)
    }
    
  }

  function featuredShowCode(index, variant) {
    if ($('.product-card').eq(index).children('.code-card').length !== 0) {
      $('.product-card').eq(index).children('.code-card').removeClass('code-card')
      $('.product-card').eq(index).children('.code-original').removeClass('code-original')
      $('.product-card').eq(index).find('.homepagebox').hide()

      allCodeDate.forEach((inele) => {
        if (variant === inele.variant_id && inele.index === index) {
          haveSetCode(inele)
        }
      })
    } else if ($('.product-card').eq(index).find('.homepagebox').length !== 0) {
      allCodeDate.forEach((inele) => {
        if (variant === inele.variant_id && inele.index === index) {
          haveSetCode(inele)
        }
      })
    } else if ($('.product-card').eq(index).children('.homepageicon-box').length !== 0) {
      $('.product-card').eq(index).children('.homepageicon-box').hide()
      allCodeDate.forEach((inele) => {
        if (variant === inele.variant_id && inele.index === index) {
          haveSetCode(inele)
        }
      })
    } else {
      allCodeDate.forEach((inele) => {
        if (variant === inele.variant_id && inele.index === index) {
          setCode(inele)
        }
      })
    }
  }

  $('.product-card__info .product-card__variant-list .thumbnail-swatch')
    .click(function (e) {
      try {
        const imgTimeout = setTimeout(() => {
          let isHaveCode = false
          let positionIndex = $(this).index()
          let position = 1
          if (positionIndex % 2 === 1) {
            position = Math.ceil(positionIndex / 2);
          } else {
            position = positionIndex / 2;
          }
          const handle = splitData(
            $(e.target).parents('.product-card__info').find('.product-card__title').children('.bold').attr('href')
          )
          fristShowlist.forEach((ele, index) => {
            if (ele === handle) {
              if ($('.product-card').eq(index).children('.code-card').length !== 0) {
                $('.product-card').eq(index).children('.code-card').removeClass('code-card')
                $('.product-card').eq(index).children('.code-original').removeClass('code-original')
                $('.product-card').eq(index).find('.homepagebox').hide()

                allCodeDate.forEach((inele) => {
                  if (handle == inele.product_handle && position === inele.position) {
                    haveSetCode(inele)
                  }
                })
              } else if ($('.product-card').eq(index).find('.homepagebox').length !== 0) {
                allCodeDate.forEach((inele) => {
                  if (handle == inele.product_handle && position === inele.position) {
                    haveSetCode(inele)
                  }
                })
              } else if ($('.product-card').eq(index).children('.homepageicon-box').length !== 0) {
                $('.product-card').eq(index).children('.homepageicon-box').hide()
                allCodeDate.forEach((inele) => {
                  if (handle == inele.product_handle && position === inele.position) {
                    haveSetCode(inele)
                  }
                })
              } else {
                allCodeDate.forEach((inele) => {
                  if (handle == inele.product_handle && position === inele.position) {
                    setCode(inele)
                  }
                })
              }
            }
          })
          clearTimeout(imgTimeout)
        }, 200)
      } catch (error) {
        console.log(error)
      }
    })

  // splitData('/products/uv-shield-lycra-gloves#i-review-app')
  function splitData(data) {
    let lastData = ''
    const index1 = data.split('/')
    const index2 = index1[2].split('#')
    if (index2[0].indexOf('?') !== -1) {
      const index3 = index2[0].split('?')
      lastData = index3[0]
    } else {
      lastData = index2[0]
    }
    return lastData
  }

  $(document).on('click', '.collection .collection__pagination .pagination__item', function () {
    fristShowlist = []
    allCodeDate = []
    let clickTimeOut = setTimeout(() => {
      porductLength = $('.product-card').length
      for (var i = 0; i < porductLength; i++) {
        fristShowlist.push($('.product-card')[i].getAttribute('handle'))
      }
      initCodeList()
      clearTimeout(clickTimeOut)
    }, 800)
  })

  function getUrlParam(url) {
    if (url.indexOf('?') !== -1) {
      const data = url.split('variant=')
      return data[1]
    } else {
      return ''
    }
  }
}

if (!window.jQuery) {
  // to be doned remove jquery
  var script = document.createElement('script')
  script.defer = true
  script.onload = function () {
    initdealCode(jQuery)
  }
  script.src = 'https://cdn.jsdelivr.net/npm/jquery@1.12.4/dist/jquery.min.js'
  document.getElementsByTagName('head')[0].appendChild(script)
} else {
  initdealCode(jQuery)
}
